function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.2 161.3C42 126.8 65.9 96.5 92.9 74.2 143.8 32 213.5 5 276.7 4.8c6.7 0 13.7.4 18.9 1.6 1.4.3 1.6 1.1.2 1.4-54 12.6-96.4 63.3-96.3 120.6 0 1.9.2 4 .4 4.9 92.5 22.5 134.4 78.3 134.7 155.5.3 77.2-60.7 161.8-163.7 162.1-73 .2-148.6-54.2-166.6-144.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  fillRule: "evenodd"
});

var SvgBrandOutline = function SvgBrandOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 341 457",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgBrandOutline;